import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDD } from 'src/app/model/generic-data';
import { MDAdd, genericMD, mdLenght, mdResponse } from 'src/app/model/masterdata/masterdata';
import { BaseResponse } from 'src/app/model/response/base-response';
import { environment } from 'src/environments/environment';
import { ErrorBaseResponse, ErroriOCRRequest, ErrorOCRBaseResponse, OCRScannedResult } from './scansione-errori';
import { FileList } from 'src/app/model/request/file';

@Injectable({
  providedIn: 'root'
})
export class ErroriService {

  private url: string = `${environment.apiUrl}/errori`;

  private urlSoluzioni: string = `${environment.apiUrl}/soluzioni`;

  private baseUrl: string = `${environment.apiUrl}/sla`;

  private tables: Array<string> = ['tipologia-cliente', 'unita-misura', 'categoria-fornitore', 'categorie', 'settori', 'settori-cliente', 'sedi', 'sla', 'tipologia-attivita', 'priorita', 'area-ticket'];
  //tabelle femminili per mettere l'articolo femminile nei messaggi tradotti in italiano
  private femTables: Array<string> = ['tipologia-cliente', 'unita-misura', 'categoria-fornitore', 'categorie', 'sedi', 'sla', 'tipologia-attivita', 'priorita', 'area-ticket'];
  //tabelle che iniziano con una vocale e quindi necessitano dell'apostrofo
  private specialTables: Array<string> = ['unita-misura'];

  constructor(private http: HttpClient) { }

  OCR(image: string): Observable<ErrorOCRBaseResponse> {
    let request: ErroriOCRRequest = { image: image };
    return this.http.post<ErrorOCRBaseResponse>(`${this.url}/ocr`, request);
  }

  filterDataNoOCR(data: string[]): Observable<ErrorOCRBaseResponse> {
    return this.http.post<ErrorOCRBaseResponse>(`${this.url}/filter`, data);
  }

  refreshOCR(data: Array<OCRScannedResult>): Observable<ErrorOCRBaseResponse> {
    return this.http.post<ErrorOCRBaseResponse>(`${this.url}/ocr-refresh`, data);
  }



  getSingleErrorForChat(codice: string): Observable<ErrorBaseResponse> {
    return this.http.get<ErrorBaseResponse>(`${this.url}/get/codice/${codice}`);
  }


  soluzioneWorkedYAY(codice: string): Observable<BaseResponse> {
    return this.http.put<BaseResponse>(`${this.urlSoluzioni}/worked/${codice}`, {});
  }

  getFiles(url: string): Observable<FileList[]> {

    return this.http.get<FileList[]>(url);
  }
}
